import { database, auth } from "../../firebase";
import {toast} from "react-toastify";

export function authUser(userName, password) {
  auth
    .signInWithEmailAndPassword(userName, password)
    .then((resp) => {
      debugger;
    })
      .catch((err) =>
          toast.error(err.message, {autoclose: false}));
}

export function signOut(){
    auth
        .signOut()
        .catch((err) =>
            toast.error(err.message, {autoclose: false}));
}

export function registerUser(userName, password, email) {
  auth
    .createUserWithEmailAndPassword(email, password)
    .then((resp) => {
      let uid = resp.user.uid;
      let obj = {
        email,
        userName,
        uid,
      };
      database.ref().child("users").child(uid).push(obj);
    })
    .catch((err)=>{
    }
      
      
      );
}

export function getCurrentUser(uid) {
  return database
    .ref(`/users/${uid}`)
    .once("value")
    .then((snapshot) => {
      return snapshot.val();
    });
}

export function getCreditzLength(uid) {
  return database
    .ref(`/user-posts/${uid}`)
    .once("value")
    .then((snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        array.push(childSnapshot.key);
      });
      return array;
    });
}

export function getPostLength(uid) {
    return database
        .ref(`/user-creditz/${uid}`)
        .once("value")
        .then((snapshot) => {
            const array = [];
            snapshot.forEach((childSnapshot) => {
                array.push(childSnapshot.key);
            });
            return array;
        });
}

export function getUserMusics(id) {
  return database
    .ref(`/posts/${id}`)
    .once("value")
    .then((snapshot) => {
      return { id, ...snapshot.val() };
    });
}

export function getAchivements(id) {
  return database
    .ref(`/achievements/${id}`)
    .once("value")
    .then((snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        array.push({ childKey, childData });
      });
      return array;
    });
}

export function updateUserStatus(currentUser) {
  return database
    .ref(`/users/${currentUser.uid}`)
    .update({
      ...currentUser,
    })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
}

export function getAllAchievements(uid) {
  return database
    .ref(`/user-achievements/${uid}`)
    .once("value")
    .then((snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        array.push({ id: childSnapshot.key, ...childData });
      });
      return array;
    });
}
